const request = async data => {
    let request_url = `/orders/${data.product_id}`;
    return fetch(request_url, {
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': `'${data.token}'`,
        },
        method: "POST",
        body: JSON.stringify(data)
    });
};

const elements = [...document.querySelectorAll('.order form .quantity')];

const getList = element => {
    let minus = element.parentNode.querySelector('a.minus');
    let add = element.parentNode.querySelector('a.plus');
    return {
        'parent': element.parentElement.parentElement.parentElement,
        'add' : add,
        'minus' : minus,
        'input': element,
        'token': element.dataset.csrf,
        'product_id': element.dataset.productId,
        'multiplier': element.dataset.multiplier,
    }
}

const changeValue = direction => item => e => {
    e.preventDefault();
    let input = item.input;

    let originalValue = input.value;
    let newValue = input.value;

    newValue = (direction == 'increment')
        ? parseInt(input.value) + 1
        : parseInt(input.value) - 1;

    newValue = (newValue < 0)
        ? 0
        : newValue;

    let siblings = [...item.parent.querySelectorAll('input.quantity')];
    let stock = parseInt(input.dataset.stock);
    let total = (direction == 'increment')
        ? parseInt(input.dataset.multiplier)
        : parseInt(input.dataset.multiplier) * (-1);
    siblings.forEach(function(el) {
        total +=+ (parseInt(el.dataset.multiplier) * parseInt(el.value));
    });

    if(total > stock) {
        originalValue = parseInt(newValue-((total-stock)/input.dataset.multiplier));
        if(originalValue < 0) {
            originalValue = 0;
        }
    }

    input.value = (total > stock)
        ? originalValue
        : newValue;

    let stockNotificationElement = item.parent.parentElement.parentElement.parentElement.getElementsByClassName('stockNotification');
    if(stockNotificationElement) {
        if(total > stock && stockNotificationElement[0]) {
            stockNotificationElement[0].style.display = 'block';
        } else if (stockNotificationElement[0]) {
            stockNotificationElement[0].style.display = 'none';
        }
    }
    input.dispatchEvent(new Event('change'));
};

const incrementValue = changeValue('increment');
const decrementValue = changeValue('decrement');

const updatePrice = input => async result => {
    let id = input.getAttribute('id');
    let fractional = result.price.priceFractional;
    let priceElement = document.getElementById(`price_${id}`);
    priceElement.innerHTML = `${result.price.priceIntegral},<sup>${fractional}</sup>`;
    return await result;
}

const updateCart = item => async result => {    

    let itemCount = document.getElementById(`cart-total-count`);
    itemCount.innerHTML = `${result.itemCount}`;

    let priceElement = document.getElementById(`price`);
    priceElement.innerHTML = `${result.cartSubTotal}`;
    
    let loadFactorElement = document.getElementById(`loadout`);
    loadFactorElement.innerHTML = `${result.loadFactor} CC kar`;
    return await result;
}

const getQuantity = (total, item) => {
    let stock = parseInt(item.dataset.stock);
    let originalValue = item.value;
    let quantity = (parseInt(item.dataset.multiplier) * parseInt(item.value));
    total = total + quantity;

    return total; 
}

const callback = item => e => {
    let siblings = [...item.parent.querySelectorAll('input.quantity')];
    let last = siblings[siblings.length - 1];
    let stock = parseInt(last.dataset.stock);
    let total = 0;
    siblings.forEach(function(el) {
        total +=+ (parseInt(el.dataset.multiplier) * parseInt(el.value));
    });
    let quantity = siblings.reduce(getQuantity, 0);

    let stockNotificationElement = item.parent.parentElement.parentElement.parentElement.getElementsByClassName('stockNotification');
    if (stockNotificationElement) {
        if(total > stock && stockNotificationElement[0]) {
            quantity = stock;
            stockNotificationElement[0].style.display = 'block';
        } else if (stockNotificationElement[0]) {
            stockNotificationElement[0].style.display = 'none';
        }
    }

    let setPrice = updatePrice(last);
    let setCart = updateCart(item);
    let result = request({
        '_token': item.token,
        'product_id': item.product_id,
        'quantity': quantity
    });

    result.then(response => response.json())
        .then(setPrice)
        .then(setCart);
}

const setListener = item => {
    let increment = incrementValue(item);
    item.add.addEventListener('click', increment);

    let decrement = decrementValue(item);
    item.minus.addEventListener('click', decrement);

    let callbackInput = callback(item);
    item.input.addEventListener('change', callbackInput);
}

export default () => {
    if(elements) {
        let list = elements.map(getList);
        list.forEach(setListener);    

        /*list.forEach(function(item){
            let callbackInput = callback(item);
            callbackInput();
        });*/
    }  
}
